import { License } from "../../api/api-generated";
import { LicenseFilter } from "./licensesTypes";

export const licenseValidator = (item: any) => {
  if (!item.software && !item.softwareId) return false;
  if (!item.company && !item.companyId) return false;
  if (!item.hardware && !item.hardwareId) return false;
  if (!item.license) return false;
  return true;
};

export const licensesMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: any,
  autoboxLabel?: string
) => {
  if (autoboxLabel === "software") return { software: autoboxValue };
  if (autoboxLabel === "hardware") return { hardware: autoboxValue };
  if (autoboxLabel === "module") return { module: autoboxValue };
  return {};
};

export const filterLicense = (
  item: License,
  filters: LicenseFilter | undefined
): boolean => {
  if (!filters) return true;
  if (filters.hardware && filters.hardware.id !== item.hardwareId) return false;
  if (filters.software && filters.software.id !== item.softwareId) return false;
  if (filters.module && filters.module.id !== item.moduleId) return false;
  return true;
};
